import React from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";

import CommentAvatar from "./CommentAvatar";
import type { Comment } from "./VTBCommentTypes";

interface CommentListProps {
  comments: Comment[];
}

const CommentList: React.FC<CommentListProps> = ({ comments }) => {
  return (
    <Box mt={3}>
      {comments.map((comment, index) => (
        <Box key={`${comment.user_id ?? "comment"}-${index}`} mb={2}>
          <Stack direction="row" spacing={2}>
            <CommentAvatar
              first_name={comment.first_name}
              user_id={comment.user_id ?? 0}
            />

            <Box>
              <Typography fontWeight="bold">
                {comment.first_name || "GuestUser"}
              </Typography>

              <Typography>{comment.vid_comment}</Typography>

              {comment.updated_on && (
                <Typography variant="caption" color="text.secondary">
                  {new Date(comment.updated_on).toLocaleString()}
                </Typography>
              )}
            </Box>
          </Stack>

          {index !== comments.length - 1 && <Divider sx={{ my: 2 }} />}
        </Box>
      ))}
    </Box>
  );
};

export default CommentList;
